
import { Ticket } from "@/models/ticket";
import { TicketService } from "@/services/ticket-service";
import Vue from "vue";

export default Vue.extend({
	props: {
		ticket: {
			type: Object as ()=>Ticket,
			required: true
		}
	},
	computed: {
		checked():boolean{
			return this.ticket.isPinned();
		}
	},
	methods: {
		async onClick(){
			if (this.ticket.isPinned()){
				await TicketService.unpin(this.ticket);
			}else{
				await TicketService.pin(this.ticket);
			}
		}
	}
});
